<div class="container">
  <div class="top-bar">
    <div class="left">
      <div class="back">
        <cs-icon-button iconType="icon" icon="fi-arrow-left" color="secondary" size="12" (buttonClick)="back()">
        </cs-icon-button>
      </div>
      <div class="title">{{service.detailTitle }}</div>
    </div>
    <div class="close">
      <cs-icon-button iconType="icon" icon="fi-x" size="12" color="secondary" (buttonClick)="close()"> </cs-icon-button>
    </div>
  </div>
  <div class="content">
    <p class="detail" [innerHTML]="service.detailContent"></p>
    <p class="date">{{ service.detailSendTime }}</p>
    <cs-button [label]="'go_back' | translate" [color]="'primary'" (buttonClick)="back()"></cs-button>
  </div>
</div>
